import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { applyDocumentDirection } from './direction';


// Import translation files
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enClients from './locales/en/clients.json';
import enSessions from './locales/en/sessions.json';
import enWorkspace from './locales/en/workspace.json';
import enImages from './locales/en/images.json';
import enNavigation from './locales/en/navigation.json';
import enChildAuth from './locales/en/childAuth.json';
import enBoards from './locales/en/boards.json';
import enHome from './locales/en/home.json';
import enAccessibility from './locales/en/accessibility.json';
import enOnboarding from './locales/en/onboarding.json';
import enProfile from './locales/en/profile.json';
import enSettings from './locales/en/settings.json';
import enUpload from './locales/en/upload.json';
import enBilling from './locales/en/billing.json';
import enErrors from './locales/en/errors.json';

// Import Spanish translations
import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esClients from './locales/es/clients.json';
import esSessions from './locales/es/sessions.json';
import esWorkspace from './locales/es/workspace.json';
import esImages from './locales/es/images.json';
import esNavigation from './locales/es/navigation.json';
import esChildAuth from './locales/es/childAuth.json';
import esBoards from './locales/es/boards.json';
import esHome from './locales/es/home.json';
import esAccessibility from './locales/es/accessibility.json';
import esOnboarding from './locales/es/onboarding.json';
import esProfile from './locales/es/profile.json';
import esSettings from './locales/es/settings.json';
import esUpload from './locales/es/upload.json';
import esBilling from './locales/es/billing.json';
import esErrors from './locales/es/errors.json';

// Import Italian translations
import itCommon from './locales/it/common.json';
import itAuth from './locales/it/auth.json';
import itClients from './locales/it/clients.json';
import itSessions from './locales/it/sessions.json';
import itWorkspace from './locales/it/workspace.json';
import itImages from './locales/it/images.json';
import itNavigation from './locales/it/navigation.json';
import itChildAuth from './locales/it/childAuth.json';
import itBoards from './locales/it/boards.json';
import itHome from './locales/it/home.json';
import itAccessibility from './locales/it/accessibility.json';
import itOnboarding from './locales/it/onboarding.json';
import itProfile from './locales/it/profile.json';
import itSettings from './locales/it/settings.json';
import itUpload from './locales/it/upload.json';
import itBilling from './locales/it/billing.json';
import itErrors from './locales/it/errors.json';

// Import French translations
import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frClients from './locales/fr/clients.json';
import frSessions from './locales/fr/sessions.json';
import frWorkspace from './locales/fr/workspace.json';
import frImages from './locales/fr/images.json';
import frNavigation from './locales/fr/navigation.json';
import frChildAuth from './locales/fr/childAuth.json';
import frBoards from './locales/fr/boards.json';
import frHome from './locales/fr/home.json';
import frAccessibility from './locales/fr/accessibility.json';
import frOnboarding from './locales/fr/onboarding.json';
import frProfile from './locales/fr/profile.json';
import frSettings from './locales/fr/settings.json';
import frUpload from './locales/fr/upload.json';
import frBilling from './locales/fr/billing.json';
import frErrors from './locales/fr/errors.json';

// Import German translations
import deCommon from './locales/de/common.json';
import deAuth from './locales/de/auth.json';
import deClients from './locales/de/clients.json';
import deSessions from './locales/de/sessions.json';
import deWorkspace from './locales/de/workspace.json';
import deImages from './locales/de/images.json';
import deNavigation from './locales/de/navigation.json';
import deChildAuth from './locales/de/childAuth.json';
import deBoards from './locales/de/boards.json';
import deHome from './locales/de/home.json';
import deAccessibility from './locales/de/accessibility.json';
import deOnboarding from './locales/de/onboarding.json';
import deProfile from './locales/de/profile.json';
import deSettings from './locales/de/settings.json';
import deUpload from './locales/de/upload.json';
import deBilling from './locales/de/billing.json';
import deErrors from './locales/de/errors.json';

// Import Hebrew translations
import heCommon from './locales/he/common.json';
import heAuth from './locales/he/auth.json';
import heClients from './locales/he/clients.json';
import heSessions from './locales/he/sessions.json';
import heWorkspace from './locales/he/workspace.json';
import heImages from './locales/he/images.json';
import heNavigation from './locales/he/navigation.json';
import heChildAuth from './locales/he/childAuth.json';
import heBoards from './locales/he/boards.json';
import heHome from './locales/he/home.json';
import heAccessibility from './locales/he/accessibility.json';
import heOnboarding from './locales/he/onboarding.json';
import heProfile from './locales/he/profile.json';
import heSettings from './locales/he/settings.json';
import heUpload from './locales/he/upload.json';
import heBilling from './locales/he/billing.json';
import heErrors from './locales/he/errors.json';

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    clients: enClients,
    sessions: enSessions,
    workspace: enWorkspace,
    images: enImages,
    navigation: enNavigation,
    childAuth: enChildAuth,
    boards: enBoards,
    home: enHome,
    accessibility: enAccessibility,
    onboarding: enOnboarding,
    profile: enProfile,
    settings: enSettings,
    upload: enUpload,
    billing: enBilling,
    errors: enErrors,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    clients: esClients,
    sessions: esSessions,
    workspace: esWorkspace,
    images: esImages,
    navigation: esNavigation,
    childAuth: esChildAuth,
    boards: esBoards,
    home: esHome,
    accessibility: esAccessibility,
    onboarding: esOnboarding,
    profile: esProfile,
    settings: esSettings,
    upload: esUpload,
    billing: esBilling,
    errors: esErrors,
  },
  it: {
    common: itCommon,
    auth: itAuth,
    clients: itClients,
    sessions: itSessions,
    workspace: itWorkspace,
    images: itImages,
    navigation: itNavigation,
    childAuth: itChildAuth,
    boards: itBoards,
    home: itHome,
    accessibility: itAccessibility,
    onboarding: itOnboarding,
    profile: itProfile,
    settings: itSettings,
    upload: itUpload,
    billing: itBilling,
    errors: itErrors,
  },
  fr: {
    common: frCommon,
    auth: frAuth,
    clients: frClients,
    sessions: frSessions,
    workspace: frWorkspace,
    images: frImages,
    navigation: frNavigation,
    childAuth: frChildAuth,
    boards: frBoards,
    home: frHome,
    accessibility: frAccessibility,
    onboarding: frOnboarding,
    profile: frProfile,
    settings: frSettings,
    upload: frUpload,
    billing: frBilling,
    errors: frErrors,
  },
  de: {
    common: deCommon,
    auth: deAuth,
    clients: deClients,
    sessions: deSessions,
    workspace: deWorkspace,
    images: deImages,
    navigation: deNavigation,
    childAuth: deChildAuth,
    boards: deBoards,
    home: deHome,
    accessibility: deAccessibility,
    onboarding: deOnboarding,
    profile: deProfile,
    settings: deSettings,
    upload: deUpload,
    billing: deBilling,
    errors: deErrors,
  },
  he: {
    common: heCommon,
    auth: heAuth,
    clients: heClients,
    sessions: heSessions,
    workspace: heWorkspace,
    images: heImages,
    navigation: heNavigation,
    childAuth: heChildAuth,
    boards: heBoards,
    home: heHome,
    accessibility: heAccessibility,
    onboarding: heOnboarding,
    profile: heProfile,
    settings: heSettings,
    upload: heUpload,
    billing: heBilling,
    errors: heErrors,
  },
};

// Mirror the document to match the language actually being rendered.
//
// Subscribed *before* init and applied again from the init callback: the listener covers
// every later changeLanguage() caller (LanguageSelector, LogoutNotification, tests) without
// each of them having to remember to touch the DOM, and the callback covers the initial
// language that LanguageDetector resolves during init itself.
//
// `resolvedLanguage`, not the requested code. LanguageDetector reads navigator.language, so
// a browser set to Hebrew asks for 'he-IL' whether or not a Hebrew bundle exists — and until
// one does, i18next serves English from fallbackLng. Keying off the request would mirror the
// layout and label it lang="he-IL" while rendering English. `resolvedLanguage` is 'en' in
// that case and 'de' for a 'de-DE' browser, so this stays correct in both directions and
// starts mirroring on its own the moment the 'he' bundle lands.
const applyResolvedDirection = (): void => {
  applyDocumentDirection(i18n.resolvedLanguage ?? i18n.language);
};

i18n.on('languageChanged', applyResolvedDirection);

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    // Common options
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Namespace separation
    defaultNS: 'common',
    ns: ['common', 'auth', 'clients', 'sessions', 'workspace', 'images', 'navigation', 'childAuth', 'boards', 'home', 'accessibility', 'onboarding', 'profile', 'settings', 'upload', 'billing', 'errors'],

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    // React options
    react: {
      useSuspense: false,
    },

    // Load all namespaces immediately
    load: 'all',
    preload: ['en'],
  }, applyResolvedDirection);

export default i18n;